import { View } from 'es6/components/view'
import { Defaults } from 'es-decorators'
import { NotificationView } from './notification-view'

/**
 * Вид уведомлений.
 */
@Defaults({
  el: '.notifications-wrapper',
})
export class NotificationsView extends View {
  /** @inheritDoc */
  run () {
    this.childViews.notifications = []
  }

  /**
   * Добавляет уведомления.
   * @param {string} notificationInner Элемент уведомления.
   * @param {boolean} [withCross] Признак наличия крестика для закрытия уведомления.
   * @param {(number|null)} [timeToShow] Время показа уведомления. Если равно null, то не будет скрываться.
   * @param {Object} events События для уведомления.
   * @param {(number|null)} [animationDuration] Скорость анимации.
   */
  createNotification (notificationInner, withCross, timeToShow, events, animationDuration) {
    this.childViews.notifications.push(
      new NotificationView({
        notificationInner,
        animationDuration,
        timeToShow,
        handleRemove: this.handleRemove.bind(this),
      }).render(this.$el, withCross, events)
    )
  }

  /**
   * Обработчик удаления уведомления, фильтрует по контексту.
   * @param {NotificationView} notificationView Вью уведомления.
   */
  handleRemove (notificationView) {
    this.childViews.notifications = this.childViews.notifications.filter(view => view !== notificationView)
  }
}
